// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const RadioCardContract = contract({
  name: "RadioCard",
  description: "Single-select where each option is a whole selectable card (shipping options, plan picker, onboarding choices). The whole card is the control, so focus and the checked state live on the card surface and the entire card is clickable. MUST sit inside a RadioGroup (keeps roving focus + single-select). Static content only — never nest an interactive control (Slider/Input/Button/link) inside. For a plain radio + label row use Field instead.",
  import: "@gradeui/ui",
  aliases: ["radio card","selectable card","option card","plan picker","choice card","pricing tier","segmented choice card"],
  composesWith: ["RadioGroup (required parent)","Badge (in aside)","MediaSurface (custom children)"],
  props: {
  "value": {
      schema: z.string(),
      design: "content",
      description: "the radio value",
  },
  "label": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "title line",
  },
  "description": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "secondary line",
  },
  "aside": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "slot before the indicator (a Badge, price, hint)",
  },
  "hideIndicator": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "hide the dot; selection shown by the card border + background",
  },
  "indicatorPosition": {
      schema: z.enum(["leading", "trailing"]).optional(),
      design: "knob",
      description: "default trailing",
  },
  "children": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "arbitrary static content (image, custom layout) instead of label/description",
  },
  },
});
